import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import logoUrl from '../lendnation-logo-v2.svg';

class Logo extends Component {
  render() {
    return (
      <footer className="apply-now-footer">
        <Row>
          <Col lg="3" sm="4" xs="6">
            <img
              src={logoUrl}
              alt="CashMax"
              className="img-responsive logo-img"
            />
          </Col>
          <Col>
            <small>
              Customer Notice: There are a wide variety of loan
              products available in the marketplace, so your choice of
              lending products should match your financial needs.
              Small-dollar loans used over a long period of time can
              be expensive.
            </small>
          </Col>
        </Row>
      </footer>
    );
  }
}
export default Logo;
